const roadStepExpenseReportConfig = (expenseReportStatus) => {
    const isStepDisabled = (step) => {
        if (expenseReportStatus === 3) return true; // Cannot modify when expense report is paid

        // Ordered list of step statuses
        const stepStatuses = [0, 1, 2, 3];

        let currentStepIndex = -1;
        for (let i = 0; i < stepStatuses.length; i++) {
            if (expenseReportStatus >= stepStatuses[i]) {
                currentStepIndex = i;
            }
            else {
                break;
            }
        }

        const stepIndex = stepStatuses.indexOf(step);
        
        if (stepIndex === -1) {
            return true;
        }

        if (stepIndex <= currentStepIndex) {
            return true;
        }

        if (stepIndex > currentStepIndex + 1) {
            return true;
        }

        return false;
    }

    return({
        color: 'orange',
        width: 'w-7/12',
        items: [
            {
                title: 'En cours',
                disabled: isStepDisabled(0)
            },
            {
                title: 'À vérifier',
                disabled: isStepDisabled(1)
            },
            {
                title: 'À payer',
                disabled: isStepDisabled(2)
            },
            {
                title: 'Payée',
                disabled: isStepDisabled(3)
            }
        ]
    })
};

export default roadStepExpenseReportConfig;
